import {ProductType} from "./model/common";

export const getTypePath = (type: ProductType) => {
    switch (type) {
        case ProductType.EMTPL: return 'mtpl'
        case ProductType.GREEN_CARD: return 'mtpl'//'green-card' - common backend used
        case ProductType.TRAVEL: return 'travel'
    }
}



